
(function(c){var d=document,a='appendChild',i='styleSheet',s=d.createElement('style');s.type='text/css';d.getElementsByTagName('head')[0][a](s);s[i]?s[i].cssText=c:s[a](d.createTextNode(c));})
('.wdn-extlatin{font-family:\'Mercury SSm Ext Latin A\',\'Mercury SSm Ext Latin B\',Georgia,serif;font-style:normal;font-weight:400}');
